import React from 'react';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme, DqLoadingProps>(theme => ({
  content: props => ({
    alignItems: 'center',
    justifyContent: 'center',
    width: props.width || '150px',
  }),
  image: {
    display: 'block',
    paddingBottom: '5px',
    margin: 'auto',
    width: '70%',
  },
  colorPrimary: props => ({
    backgroundColor: props.primaryBar ? props.primaryBar : theme.palette.secondary.light,
  }),
  barColorPrimary: props => ({
    backgroundColor: props.primaryBar ? props.secondaryBar : theme.palette.primary.light,
  }),
}));

interface DqLoadingProps {
  circular?: boolean;
  text?: string;
  img?: any;
  primaryBar?: string;
  secondaryBar?: string;
  width?: string;
}

export const DqLoading: React.FC<DqLoadingProps> = props => {
  const classes = useStyles(props);

  return (
    <div className={classes.content}>
      {props.img && <img src={props.img} className={classes.image} alt="sentinel-logo" />}
      {!props.circular && (
        <LinearProgress
          classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }}
          style={{ width: props.width || '150px' }}
          color="primary"
        />
      )}
      {props.circular && <CircularProgress color="inherit" />}
      {props.text && (
        <Typography variant="subtitle2" color="textSecondary" align="center">
          {props.text}
        </Typography>
      )}
    </div>
  );
};
